export default {
  LOGOUT_BEGIN: "LOGOUT_BEGIN",
  LOGOUT_SUCCESS: "LOGOUT_SUCCESS",
  LOGOUT_FAILURE: "LOGOUT_FAILURE",

  GET_CURRENT_USER_BEGIN: "GET_CURRENT_USER_BEGIN",
  GET_CURRENT_USER_SUCCESS: "GET_CURRENT_USER_SUCCESS",
  GET_CURRENT_USER_FAILURE: "GET_CURRENT_USER_FAILURE",
};



// WEBPACK FOOTER //
// ./src/modules/menu/constants.js